export const authRoles = {
    dashboard: ['Super Admin','Hotel Owner','Agent' ],
    default:['default-roles-lyfetraveller'],
    super_admin:[
        'Super Admin'
    ],
    hotel_owner:['Hotel Owner'],
    admin_side:['Super Admin'],
    control:['Super Admin','Hotel Owner'],
    agent:['Agent'],

    booking:['Agent','Hotel Owner'],
    profile:['Super Admin','Hotel Owner','Agent'],
    agent_earning:['Super Admin','Agent'],
}



